import cx from 'classnames';
import React, { useMemo } from 'react';
import Styles from './DomElements.scss';
import Label from './Label';

interface ITextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    type?: string;
    containerClassName?: string;
    containerStyle?: React.CSSProperties;
    inputClassName?: string;
    inputStyle?: React.CSSProperties;
    isEditing?: boolean;
    name?: string;
    value?: string | number | any;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    id?: string;
    textArea?: boolean;
    rows?: number;
}

const TextInput = React.forwardRef(function CustomInput(
    props: ITextInputProps,
    ref: React.ForwardedRef<HTMLInputElement>
) {
    const {
        containerClassName,
        containerStyle,
        label,
        inputClassName,
        inputStyle,
        type,
        isEditing,
        value,
        name,
        textArea,
        ...inputProps
    } = props;
    const inputType = type ? type : 'text';

    const innerHtml = useMemo(() => {
        if (isEditing) {
            const editProps = {
                type: inputType,
                className: cx(
                    textArea ? Styles.textarea : Styles.textbox,
                    inputClassName
                ),
                style: inputStyle,
                name: name,
                value: value,
                ...inputProps,
            };

            const Element = textArea ? <textarea /> : <input />;

            return React.cloneElement(Element, editProps);
        } else {
            return (
                <div
                    className={cx(Styles.textbox, inputClassName)}
                    style={inputStyle}
                >
                    {value}
                </div>
            );
        }
    }, [isEditing, textArea, value]);

    return (
        <div
            className={cx(Styles.domElContainer, containerClassName)}
            style={containerStyle}
            ref={ref}
        >
            {label && <Label text={label} />}
            {innerHtml}
        </div>
    );
});

TextInput.defaultProps = {
    isEditing: true,
};

export default TextInput;
